import React from 'react';
import MatchTable from '../Common/MatchTable';
import { Remark } from '../Common/MatchBase';

const HIL = () => {
    return (
        <section className='HIL'>
            <MatchTable betType='HIL' etBetType="EHL" />
            <Remark />
        </section>
    )
}
export default HIL;